import { atomWithStorage } from '@capsicum/common';

export const walletTutorialCompletedAtom = atomWithStorage('walletTutorialCompleted', false);
